
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M27.767 4.329c.273-.37.317-.862.114-1.275a1.198 1.198 0 0 0-1.073-.673H5.206c-.454 0-.87.26-1.072.673-.203.413-.16.906.113 1.275l9.36 12.771v12.064c0 .461.257.882.664 1.088.406.207.891.162 1.255-.114l2.397-1.827c.303-.23.48-.59.48-.973V17.099l9.364-12.77z","stroke":"currentColor","stroke-width":"2","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","vector-effect":"non-scaling-stroke"}})])
          )
        }
      }
    